<app-dialog-container>
    <h1 mat-dialog-title>
        Adicionar Dados do Comerciante
        <button mat-icon-button
            color="accent"
            (click)="fillMockData()"
            matTooltip="Preencher com dados de teste"
            style="float: right;">
            <mat-icon>science</mat-icon>
        </button>
    </h1>

    <div mat-dialog-content>
        <form [formGroup]="merchantForm" (ngSubmit)="add()">

            <div fxLayout="row wrap" fxLayoutGap="20px grid">

                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('chavePix')" 
                        [group]="merchantForm"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)" class="pt-2">
                    <app-input [config]="getFieldConfig('celularFinanceiro')"
                        [group]="merchantForm"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('emailFinanceiro')"
                        [group]="merchantForm"></app-input>
                </div>

                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('responsavelNome')"
                        [group]="merchantForm"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('responsavelCpf')"
                        [group]="merchantForm"
                        (onChange)="handleCpfChange()"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('responsavelRg')"
                        [group]="merchantForm"></app-input>
                </div>

                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input
                        [config]="getFieldConfig('responsavelNacionalidade')"
                        [group]="merchantForm"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('responsavelCelular')"
                        [group]="merchantForm"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('responsavelEmail')"
                        [group]="merchantForm"></app-input>
                </div>

                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input
                        [config]="getFieldConfig('responsavelDataNascimento')"
                        [group]="merchantForm"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('responsavelCep')"
                        [group]="merchantForm"
                        (onChange)="handleCepChange('responsavel')"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('responsavelEstado')"
                        [group]="merchantForm"></app-input>
                </div>

                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('responsavelCidade')"
                        [group]="merchantForm"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('responsavelBairro')"
                        [group]="merchantForm"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('responsavelEndereco')"
                        [group]="merchantForm"></app-input>
                </div>

                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('responsavelNumero')"
                        [group]="merchantForm"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input
                        [config]="getFieldConfig('responsavelComplemento')"
                        [group]="merchantForm"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('idExterno')"
                        [group]="merchantForm"></app-input>
                </div>

                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('tipoConta')"
                        [group]="merchantForm"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)" class="pt-2">
                    <!-- Padding-top para alinhar visualmente com os outros campos -->
                    <app-input [config]="getFieldConfig('validarIp')"
                        [group]="merchantForm"></app-input>
                </div>
                <div fxFlex="1 1 calc(33.3% - 20px)">
                    <app-input [config]="getFieldConfig('ips')"
                        [group]="merchantForm"></app-input>
                </div>

            </div>
        </form>
    </div>

    <div mat-dialog-actions align="end">
        <button mat-button (click)="cancel()">Cancelar</button>
        <button mat-raised-button color="primary"
            [disabled]="merchantForm.invalid || typeCes === typeCesEnum.SHOW" (click)="add()">Salvar</button>
    </div>
</app-dialog-container>